import { Component } from 'react';
import { connect } from 'react-redux';

import { authorizationRequest } from 'ducks/auth';

class Authenticate extends Component {
  componentDidMount() {
    this.props.authorizationRequest();
  }

  render() {
    return this.props.children;
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user || false
  };
};

const mapDispatchToProps = {
  authorizationRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(Authenticate);
